'use client';

import type { PropsWithChildren } from 'react';
import type { CriteriaChoiceUserType } from '~/model/CriteriaChoiceType';
import type { CriteriaType } from '~/model/CriteriaType';
import { createContext, useContext } from 'react';
import { useProfileCompletion } from '@/app/hooks/useProfileCompletion';

const ProfileCompletionContext = createContext<ReturnType<typeof useProfileCompletion> | undefined>(undefined);

export const useProfileCompletionContext = () => {
  const context = useContext(ProfileCompletionContext);
  if (!context) {
    throw new Error(
      'useProfileCompletionContext must be called within ProfileCompletionContext',
    );
  }
  return context;
};

export const ProfileCompletionProvider = ({
  children,
  requestedCriteria,
  requestedCriteriaChoiceUser,
  mandatoryCriteria,
  mandatoryCriteriaChoiceUser,
  shouldUpdateSports,
}: PropsWithChildren<{
  requestedCriteria: Array<CriteriaType>;
  requestedCriteriaChoiceUser: Array<CriteriaChoiceUserType>;
  mandatoryCriteria: Array<CriteriaType>;
  mandatoryCriteriaChoiceUser: Array<CriteriaChoiceUserType>;
  shouldUpdateSports: boolean;
}>) => {
  const value = useProfileCompletion({
    requestedCriteria,
    requestedCriteriaChoiceUser,
    mandatoryCriteria,
    mandatoryCriteriaChoiceUser,
    shouldUpdateSports,
  });

  return (
    <ProfileCompletionContext.Provider value={value}>
      {children}
    </ProfileCompletionContext.Provider>
  );
};
